export type TransactionActivityAction =
  | 'CREATED'
  | 'EDITED'
  | 'DOCUMENT_ATTACHED'
  | 'DOCUMENT_REMOVED'
  | 'BANK_PAYMENT_LINKED'
  | 'BANK_PAYMENT_UNLINKED'
  | 'ISSUED'
  | 'APPROVED'
  | 'MANUALLY_APPROVED';

export const TRANSACTION_ACTIVITY_LABELS: Record<
  TransactionActivityAction,
  string
> = {
  CREATED: 'Created',
  EDITED: 'Edited',
  DOCUMENT_ATTACHED: 'Document attached',
  DOCUMENT_REMOVED: 'Document removed',
  BANK_PAYMENT_LINKED: 'Bank payment linked',
  BANK_PAYMENT_UNLINKED: 'Bank payment unlinked',
  ISSUED: 'Issued',
  APPROVED: 'Approved',
  MANUALLY_APPROVED: 'Manually approved',
};

export interface TransactionActivityEntry {
  id: string;
  action: TransactionActivityAction;
  // null when the system acted.
  actor_name: string | null;
  fund_name: string | null;
  reason: string | null;
  created_at: string;
}
